import React, { Component } from 'react';
import type { ProjectCategory } from '../../../types';

type Props = {
  categories: Array<ProjectCategory>,
  onRemoveCategory: (category: ProjectCategory) => void,
  onOpenAddCategoryModal: () => void,
  onOpenEditCategoryModal: (category: ProjectCategory) => void,
};

type State = {
  categoryToDelete: ProjectCategory | null,
};

class CategoryTable extends Component<Props, State> {
  state = {
    categoryToDelete: null,
  };

  handleDeleteClick = (e: any, category: ProjectCategory) => {
    e.stopPropagation();
    this.setState({ categoryToDelete: category });
  };

  handleConfirmDelete = (e: any) => {
    e.stopPropagation();
    const { categoryToDelete } = this.state;
    const { onRemoveCategory } = this.props;

    if (categoryToDelete) {
      onRemoveCategory(categoryToDelete);
      this.setState({ categoryToDelete: null });
    }
  };

  handleCancelDelete = (e: any) => {
    e.stopPropagation();
    this.setState({ categoryToDelete: null });
  };

  renderHeader(): React.ReactNode {
    return (
      <div className="container container-header mt-4">
        <div className="upper-header-wrapper">
          <div className="left-column">
            <h2>Categories</h2>
            <hr className="float-left" />
            <p className="clearfix mb-4">List of all project categories</p>
          </div>
        </div>
        <div className="filter-result">
          <div className="text-wrapper">All categories</div>
        </div>
      </div>
    );
  }

  renderTableContent(): React.ReactNode {
    const {
      categories,
      onOpenAddCategoryModal,
      onOpenEditCategoryModal,
    } = this.props;

    return (
      <div className="container main-content">
        <div className="table-navbar">
          <div className="table-column">
            <h4>Category Name</h4>
          </div>
          <div className="table-column-end">
            <h4>Actions</h4>
          </div>
        </div>
        {categories.map(category => (
          <div
            className="table-row"
            key={category.id}
            onClick={() => onOpenEditCategoryModal(category)}
            style={{ cursor: 'pointer' }}
          >
            <div className="d-flex table-column">
              <span>
                { category.name }
              </span>
              <span
                className="color-circle"
                style={{ ['--category-color' as any]: category.color } as React.CSSProperties}
              />
            </div>
            <div className="table-column-end">
              <button
                type="button"
                className="btn btn-danger"
                onClick={(e) => this.handleDeleteClick(e, category)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
        <button
          className="add-btn"
          type="button"
          onClick={onOpenAddCategoryModal}
        >
          <i className="fa fa-plus" aria-hidden="true" />
        </button>
      </div>
    );
  }

  DeleteConfirmModal = ({
    isOpen, onClose, onConfirm, title, message,
  }) => {
    if (!isOpen) return null;

    return (
      <div className="delete-confirm-overlay" onClick={onClose}>
        <div className="delete-confirm-box" onClick={e => e.stopPropagation()}>
          <h3>{title}</h3>
          <p>{message}</p>
          <div className="delete-confirm-buttons">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-danger" onClick={onConfirm}>Delete</button>
          </div>
        </div>
      </div>
    );
  };

  render(): React.ReactNode {
    const { categoryToDelete } = this.state;
    const confirmMessage = categoryToDelete
      ? `Are you sure you want to delete "${categoryToDelete.name}"?`
      : 'Are you sure you want to delete this category?';

    return (
      <div className="small-device-category has-custom-table">
        {this.renderHeader()}
        {this.renderTableContent()}
        <this.DeleteConfirmModal
          isOpen={categoryToDelete !== null}
          onClose={() => this.setState({ categoryToDelete: null })}
          onConfirm={this.handleConfirmDelete}
          title="Confirm Delete"
          message={confirmMessage}
        />
      </div>
    );
  }
}

export default CategoryTable;
